import React from 'react';

import NotFound from 'components/practice/NewAppointment/components/NotFound';

const EmptyState = () => {
  return (
    <NotFound
      className="!pr-2 hover:bg-none"
      title="No insurance profile"
      icon="illustration-empty-income"
      description="Please add an insurance profile to run eligibility"
    />
  );
};

export default EmptyState;
